import React from "react";
import { ToastPosition } from "./style";

export interface ToastOptions {
  content: string | React.ReactNode;
  duration?: number; // 밀리초 단위, 기본값 2000
  position?: ToastPosition;
  onClick?: () => void;
  style?: React.CSSProperties; // 커스텀 스타일 추가
}

interface Toast extends ToastOptions {
  id: string;
  isExiting: boolean;
}

type ToastState = {
  toasts: Toast[];
};

type Listener = (state: ToastState) => void;

class ToastManagerClass {
  private static instance: ToastManagerClass;
  private listeners: Listener[] = [];
  private state: ToastState = {
    toasts: [],
  };

  private constructor() {}

  static getInstance(): ToastManagerClass {
    if (!ToastManagerClass.instance) {
      ToastManagerClass.instance = new ToastManagerClass();
    }
    return ToastManagerClass.instance;
  }

  addListener(listener: Listener): void {
    this.listeners.push(listener);
  }

  removeListener(listener: Listener): void {
    this.listeners = this.listeners.filter((l) => l !== listener);
  }

  show(options: ToastOptions): string {
    const id = this.generateId();
    const toast: Toast = {
      id,
      content: options.content,
      duration: options.duration || 2000,
      position: options.position || "top",
      onClick: options.onClick,
      style: options.style,
      isExiting: false,
    };


    this.state = {
      toasts: [...this.state.toasts, toast],
    };
    this.notifyListeners();

    // 자동으로 사라지는 타이머 설정
    setTimeout(() => {
      this.setExiting(id);
      setTimeout(() => {
        this.remove(id);
      }, 300); // fadeOut 애니메이션 시간
    }, toast.duration);

    return id;
  }

  setExiting(id: string): void {
    this.state = {
      toasts: this.state.toasts.map((toast) =>
        toast.id === id ? { ...toast, isExiting: true } : toast
      ),
    };
    this.notifyListeners();
  }

  remove(id: string): void {
    this.state = {
      toasts: this.state.toasts.filter((toast) => toast.id !== id),
    };
    this.notifyListeners();
  }

  private generateId(): string {
    return `toast_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
  }

  private notifyListeners(): void {
    this.listeners.forEach((listener) => listener(this.state));
  }
}

export const ToastManager = ToastManagerClass.getInstance();
